export default __webpack_public_path__ + "static/media/source-sans-pro-v12-latin-regular.33e6b01f.woff";